import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * One QueryClient for the app. Defaults tuned for an auth-gated SaaS:
 *   - retry: never retry a 4xx (a 401/403/409 is a definitive answer, not a
 *     transient blip). Retry a genuine network error a couple of times.
 *   - staleTime 30s: avoids a refetch storm on quick navigations while still
 *     keeping account data fresh.
 *   - no refetch-on-focus for muta­tions-heavy auth screens (avoids surprising
 *     reloads); the account query refetches on mount, which is what we want.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
